import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { DateInput, InputLabel } from 'components/Form';
import IsNoEndDate from '../isNoEndDate/isNoEndDate';
import messages from '../../ScheduleForm.messages';

const ScheduleDateInputs = ({ isNoEndDate, isRecurring, disabled }) => (
  <div className="grid">
    <div className="grid__item md-1/2" data-cypress="start-date-input">
      <Field
        name="startDate"
        disabled={disabled}
        component={DateInput}
        label={isRecurring ? messages.startDate : messages.date}
      />
    </div>
    {isRecurring && (
      <div className="grid__item md-1/2" data-cypress="end-date-input">
        <InputLabel message={messages.endDate} />
        {!isNoEndDate && <Field name="recurrenceEndDate" component={DateInput} className="mb-0" />}
        <Field name="isNoEndDate" component={IsNoEndDate} />
      </div>
    )}
  </div>
);

ScheduleDateInputs.propTypes = {
  isNoEndDate: PropTypes.bool,
  isRecurring: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ScheduleDateInputs;
